<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> موجودی ريالی انبار
      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="amount-inventory-chart"></chart-export-btn>
    </v-card-title>
    <canvas  height="90" id="amount-inventory-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";
export default {
  name: 'AmountInventory',
  components: {ChartExportBtn},
  data() {
    return {
      chartResult: null,
      chartData: {
        type: "bar",
        data: {
          labels: ["انبار 1", "انبار 2", "انبار 3"],
          datasets: [
            {
              label: "موجودی",
              data: [1450000, 1430000, 1530000],
              backgroundColor: "rgba(0, 35, 87,.5)",
              borderColor: "#002357",
              borderWidth: 3,
              hoverBorderWidth: 5,

            },
          ]
        },

        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          legend: {
            display: false
          },
          interaction: {
            intersect: true,
            mode: 'index',
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .12)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15
                }
              }
            ]
          }
        }
      },
    }
  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/warehouseRemainChartReport`),
        method: "get",
        success: data => {
          this.chartResult = data.results
          this.getData()
        }
      })
    },

    getData() {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []

      for (let warehouse of this.chartResult){
        this.chartData.data.labels.push(warehouse.title)
        this.chartData.data.datasets[0].data.push(warehouse.remain)

      }
      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById('amount-inventory-chart');
      new Chart(ctx, this.chartData);
    }

  },

  mounted() {
    this.getChartFromApi()
  }
}
</script>